import { Injectable } from '@angular/core';
import { DocumentEntity } from '@domain';

/**
 * Revisões de campo produzidas por escritas DESTA aba.
 *
 * O backend avança o `rev` do campo a cada escrita (texto, config, tipo, IA, mídia), e o
 * editor de texto manda como base a revisão de quando ganhou o foco. Mexer no tamanho ou
 * na cor pela barra enquanto se digita é uma escrita nossa no mesmo campo: sem isto, o
 * próximo save do texto saía com a base velha e era recusado como edição concorrente.
 *
 * Como cada escrita soma exatamente 1, a base pode "andar" por cima das revisões que são
 * nossas (`fastForward`). A de outra sessão não está aqui, então o avanço para nela e o
 * conflito continua sendo detectado.
 */
@Injectable({
    providedIn: 'root',
})
export class OwnFieldRevisionsService {
    private _revs = new Map<string, Set<number>>();

    /** Guarda a revisão do campo no documento devolvido por uma escrita nossa. */
    public record(document: DocumentEntity | null | undefined, fieldId: string): void {
        for (const session of document?.sessions ?? []) {
            const field = session.items?.find(item => item._id === fieldId);
            if (!field) continue;
            if (field.rev == null) return;

            const revs = this._revs.get(fieldId) ?? new Set<number>();
            revs.add(field.rev);
            this._revs.set(fieldId, revs);
            return;
        }
    }

    /** A base avança enquanto a revisão seguinte for de uma escrita nossa. */
    public fastForward(fieldId: string, rev: number | null | undefined): number | null {
        if (rev == null) return null;

        const revs = this._revs.get(fieldId);
        let current = rev;
        while (revs?.has(current + 1)) current++;
        return current;
    }
}
